export default "__VITE_ASSET__uQDgZ7jI__"